import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "h-100 flex-column d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-center justify-self-start" }, " Altere sua foto clicando na imagem abaixo ", -1)
const _hoisted_4 = { class: "h-100 d-flex align-items-center" }

import { computed, onMounted, ref } from "vue";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";
import { useSyncSession } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileImage',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);

const submitting = ref(false);
const uploading = ref(false);
const avatar = ref("");
const file = ref<any>(null);

const placeholder = computed(() =>
  session.value?.gender === "female"
    ? require("@/assets/img/avatars/1.png")
    : require("@/assets/img/avatars/2.png"),
);

onMounted(() => {
  avatar.value = sessionStore.session?.formatted_profile_image?.uri ?? "";
});

const { mutateAsync: updateUser } = useUpdateUser();
const { mutateAsync: syncSessionMutate } = useSyncSession();

async function onAvatarUploaded(event: any) {
  try {
    uploading.value = true;
    avatar.value = event.base64;
    file.value = event.file;
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
}

async function updateProfileImage() {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, profile_image: file.value });
    await syncSessionMutate();
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_AvatarUploader = _resolveComponent("AvatarUploader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AvatarUploader, {
          avatar: avatar.value,
          uploading: uploading.value,
          onOnAvatarUploaded: onAvatarUploaded,
          placeholder: placeholder.value
        }, null, 8, ["avatar", "uploading", "placeholder"])
      ]),
      _createVNode(_component_Button, {
        fullWidth: "",
        label: "Concluir",
        onOnClick: updateProfileImage,
        loading: submitting.value
      }, null, 8, ["loading"])
    ])
  ]))
}
}

})